import React from 'react';

// Generic device icon — image fallback for the catalog + the attached-devices cards.
export default function DeviceGlyph({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="5" y="2" width="14" height="20" rx="2" />
      <path d="M9 18h6" />
    </svg>
  );
}
